import { inject, Injectable } from '@angular/core'
import { CompanyCarrier, CompanyCarrierTestResult } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'

// todo do i need everything?
const carrierSchema = {
  id: null,
  name: null,
  color: null,
  position: null,
  tariffs: {
    id: null,
    name: null,
    const: null,
    position: null,
    cod: null,
  },
}

@Injectable({ providedIn: 'root' }) // todo do i need this
export class CompanyCarrierService {
  core = inject(CoreService)

  // todo parameters and schema
  async getCompanyCarriers(
    parameters: any = {},
    schema: any = { id: null, carrier: carrierSchema }
  ): Promise<{
    items: CompanyCarrier[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.companyCarrier.getList(parameters, schema)
  }

  // todo type carrier vs companyCarrier
  async getCompanyCarrier(id: number, schema: any = { id: null, carrier: carrierSchema }): Promise<CompanyCarrier> {
    return await this.core.services.companyCarrier.getById(id, schema)
  }

  async createCompanyCarrier(parameters: any = {}, schema: any = { id: null }): Promise<CompanyCarrier> {
    return await this.core.services.companyCarrier.create(parameters, schema)
  }

  async updateCompanyCarrier(parameters: any = {}, schema: any = { id: null }): Promise<CompanyCarrier> {
    return await this.core.services.companyCarrier.update(parameters, schema)
  }

  async deleteCompanyCarrier(parameters: any = {}): Promise<CompanyCarrier> {
    return await this.core.services.companyCarrier.delete(parameters)
  }

  // Server checks the saved options and, when the carrier supports deletion, creates and deletes a test shipment
  async testCompanyCarrier(id: number): Promise<CompanyCarrierTestResult> {
    return await this.core.services.companyCarrier.test({ id })
  }
}
